import createBreakpoint from 'shared-tokens/utils/breakpoints';
import createTransition from 'shared-tokens/utils/createTransition';
import spacings from 'shared-tokens/utils/tokens/spacings';
import colors from 'shared-tokens/utils/tokens/colors';
import typography from 'shared-tokens/utils/tokens/typography';

export const mainCls = 'modal-header';
const brXs = createBreakpoint('xs');
const brM = createBreakpoint('m');

export default {
    [mainCls]: {
        zIndex: 1,
        lineHeight: '64px',
        flexBasis: '64px !important',
        padding: `0 ${spacings.s}px`,
        transition: createTransition(['flex-basis', 'line-height', 'font-size', 'background-color', 'box-shadow', 'opacity']),
        [brXs]: {
            padding: `0 ${spacings.m}px`,
        },

        [brM]: {
            padding: `0 ${spacings.ml}px`,
        },
    },
    [`${mainCls}--scrl`]: {
        backgroundColor: 'white',
        lineHeight: '40px',
        flexBasis: '40px !important',
        boxShadow: '0 1px 4px 0 rgba(0, 0, 0, 0.1)',
        zIndex: 3,

        [`& .${mainCls}__title`]: {
            fontSize: `${typography.tpSizes.m}px`,
        },
    },
    [`${mainCls}--noshdw`]: {
        boxShadow: '0 0 0 0 rgba(0, 0, 0, 0)',
    },
    [`${mainCls}--DS`]: {
        lineHeight: '48px',
        flexBasis: '48px !important',
        [brM]: {
            lineHeight: '41px',
            flexBasis: '41px !important',
            padding: `0 ${spacings.m}px`,
        },
    },
    'whiteBg': {
        [`& .${mainCls}--scrl`]: {
            boxShadow: '0 0 0 0 rgba(0, 0, 0, 0)',
        }
    },    
    [`${mainCls}__title`]: {
        fontSize: '22px',
        transition: createTransition(['font-size']),
    },
    [`${mainCls}__DStitle`]: {
        width: 'calc(100% - 32px)',
        height: 48,
        [brM]: {
            height: 40,
            lineHeight: '40px',
        },
    },
    [`${mainCls}__DStitle--hid`]: {
        opacity: 0,
    },
    [`${mainCls}__DStitle--vis`]: {
        opacity: 1,
    },    
    [`${mainCls}__action`]: {
        width: 16,
        height: 48,
        lineHeight: '48px',
        '& svg path': {
            strokeWidth: 2,
        },
        [brM]: {
            height: 40,
            lineHeight: '40px',
            color: colors.f2.rgba,
            '&:hover': {
                color: colors.f0.rgba,
            },
            '& svg path': {
                strokeWidth: 1.5,
            },            
        },
    },
    [`${mainCls}__action--back`]: {
        height: 18,
        [brM]: {
            height: 16,
        },
    },
}